import type { PublicApiKey } from '@/apilib';
import type { createMobileEditorApi } from './mobileEditorWrapper';

export const MobileEditorApiKey: PublicApiKey<typeof createMobileEditorApi> = {
  name: 'MobileEditorApi',
  public: true,
};
